import { type AxiosInstance, type AxiosError, HttpStatusCode } from "axios";
import useSWR from "swr";
import type { KeyedMutator } from "swr";
import type { GetCommercialMonitoringReceptionBooksAPIResponse } from "@/features/commercialRegistrationMonitoring/types";
import { SendToTrackingService } from "@/api/handlers/errors";

interface IResponse {
  data: GetCommercialMonitoringReceptionBooksAPIResponse | undefined;
  isLoading: boolean;
  mutate: KeyedMutator<GetCommercialMonitoringReceptionBooksAPIResponse>;
  error: AxiosError | undefined;
}

export const GetCommercialMonitoringDetailReceptionBookAPI = (
  apiClient: AxiosInstance,
  id: number
): IResponse => {
  const fetcher = async (
    url: string
  ): Promise<GetCommercialMonitoringReceptionBooksAPIResponse> => {
    const { data } =
      await apiClient.get<GetCommercialMonitoringReceptionBooksAPIResponse>(
        url
      );
    return data;
  };

  const { data, isLoading, mutate, error } = useSWR<
    GetCommercialMonitoringReceptionBooksAPIResponse,
    AxiosError
  >(
    [`/commercial-monitoring/detail/${id}`],
    async ([url]: [string]) => await fetcher(url),
    {
      // NOTE: バックエンドの120秒制限に合わせる
      errorRetryInterval: 120_000,
      revalidateOnFocus: false,
    }
  );

  if (
    error &&
    (error.response?.status ?? HttpStatusCode.InternalServerError) >=
      HttpStatusCode.InternalServerError
  ) {
    SendToTrackingService(error);
  }

  return { data, isLoading, mutate, error };
};
